import React, { useState } from "react";
import {
  Box,
  Typography,
  Chip,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  InputAdornment,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const badgeStyle = {
  m: 0.5,
  fontWeight: "bold",
};

const COCmodal = ({ cocDetails = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const filteredCOCDetails = cocDetails.filter((item) => {
    // {console.log("item", item)}
    const vesselName = item?.contract?.vesselName || "";
    const crewName = item?.contract?.crewName || "";
     const indos = item?.contract?.crewdetails?.indosno || "";
    return (
      vesselName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      crewName.toLowerCase().includes(searchTerm.toLowerCase())  || 
      indos.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const paginatedData = filteredCOCDetails.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); // reset to page 0 on new search
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ mt: 5, px: 2 }}>
      {/* Header Bar */}
      <Paper
        elevation={3}
        sx={{
          p: 1,
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <TextField
          placeholder="Search by Vessel Name or Crew"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: "280px",
          }}
        />

        <Typography
          variant="h6"
          sx={{
            mx: "auto",
            textAlign: "center",
            flex: 1,
            fontWeight: "bold",
            color: "#f5f5f5",
          }}
        >
          COC Details
        </Typography>

        <Box sx={{ width: 300 }} />
        <Typography sx={{fontWeight: "bold"}}>Total Count: {cocDetails?.length}</Typography>
      </Paper>

      {/* Table Section */}
      <Paper elevation={3} sx={{ mt: 2 }}>
        {paginatedData.length > 0 ? (
          <>
            <Table stickyHeader>
              <TableHead>
                <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                  <TableCell sx={{ fontWeight: "bold" }}>Sr. No.</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((item, index) => {
                  const cocDate = item?.date || "N/A";
                  return (
                    <TableRow key={item._id || index}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Typography fontWeight="bold">
                          Vessel Name: {item?.contract?.vesselName || "N/A"}
                        </Typography>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                          <Chip
                            label={`Crew: ${item?.contract?.crewName || "N/A"}`}
                            color="primary"
                            sx={badgeStyle}
                          />
                          <Chip
                            label={`COC Date: ${cocDate}`}
                            sx={{
                              ...badgeStyle,
                              backgroundColor: "#ffe0b2",
                              color: "#e65100",
                            }}
                          />
                          <Chip
                            label={`Indos No.: ${
                              item?.contract?.crewdetails?.indosno || "N/A"
                            }`}
                            color="primary"
                            sx={badgeStyle}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>

            {/* MUI Table Pagination */}
            <TablePagination
              component="div"
              count={filteredCOCDetails.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
              sx={{
                px: 2,
                bgcolor: "#fafafa",
                borderTop: "1px solid #e0e0e0",
                display: "flex",
                justifyContent: "flex-end",
              }}
            />
          </>
        ) : (
          <Typography align="center" sx={{ py: 3 }}>
            No matching COC data found.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default COCmodal;
